/**
 * Accordion Item
 *
 * The question's button opens and closes its answer. A closed answer goes
 * back to `hidden="until-found"` rather than plain `hidden`, so find-in-page
 * can still reach it — and when it does, `beforematch` opens the card, which
 * is kept in step here so the button says so too.
 */

const TOGGLE = 'js-accordion-toggle';

class AccordionItem {
	constructor(button) {
		this.button = button;
		this.answer = document.getElementById(button.getAttribute('aria-controls'));

		if (!this.answer) {
			return;
		}

		this.bindEvents();
	}

	bindEvents = () => {
		this.button.addEventListener('click', this.handleClick);
		this.answer.addEventListener('beforematch', () => this.setOpen(true));
	};

	handleClick = () => {
		this.setOpen(this.button.getAttribute('aria-expanded') !== 'true');
	};

	setOpen = (open) => {
		this.button.setAttribute('aria-expanded', open ? 'true' : 'false');

		if (open) {
			this.answer.removeAttribute('hidden');
		} else {
			this.answer.setAttribute('hidden', 'until-found');
		}
	};
}

document.addEventListener('DOMContentLoaded', () => {
	[...document.querySelectorAll(`.${TOGGLE}`)].map((button) => new AccordionItem(button));
});
